import React from 'react';
import { IIconProps } from '../interfaces';

const CloseIcon = (props: IIconProps) => {

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={ props.width }
            height={ props.width }
            className={ props.classes }
            viewBox="0 0 38 38">
            <title>Close</title>
            <path fill={ props.color || '#828282' } d="M36.5606602,-0.560660172 C37.109835,-0.0114853865 37.1441584,0.857577023 36.6636304,1.44673776 L36.5606602,1.56066017 L20.12,18 L36.5606602,34.4393398 C37.1464466,35.0251263 37.1464466,35.9748737 36.5606602,36.5606602 C36.0114854,37.109835 35.142423,37.1441584 34.5532622,36.6636304 L34.4393398,36.5606602 L18,20.12 L1.56066017,36.5606602 C0.974873734,37.1464466 0.0251262658,37.1464466 -0.560660172,36.5606602 C-1.10983496,36.0114854 -1.14415838,35.142423 -0.663630444,34.5532622 L-0.560660172,34.4393398 L15.879,18 L-0.560660172,1.56066017 C-1.14644661,0.974873734 -1.14644661,0.0251262658 -0.560660172,-0.560660172 C-0.0114853865,-1.10983496 0.857577023,-1.14415838 1.44673776,-0.663630444 L1.56066017,-0.560660172 L18,15.879 L34.4393398,-0.560660172 C35.0251263,-1.14644661 35.9748737,-1.14644661 36.5606602,-0.560660172 Z" transform="translate(1 1)"/>
        </svg>
    )
};

export default CloseIcon;
